import { getTokenData, parseJwt, getUserData, clearUserData } from '../helpers/Common';
export const Username = () => {
  let sessData = parseJwt(getTokenData());
  return sessData.fullName || false;
}
export const UserId = () => {
  let sessData = parseJwt(getTokenData());
  return sessData.id || false;
}
export const hasGlobalRoute = () => {
  let sessData = parseJwt(getTokenData());
  return sessData.globalAccess || false;
}
export const getGlobalRoute = () => {
  let userData = parseJwt(getTokenData());
  let beforeRoutes = userData.beforeRoutes || [];
  let afterRoutes = userData.afterRoutes || [];
  if (beforeRoutes.length > 0) {
    return beforeRoutes[0].url;
  } else if (afterRoutes.length > 0) {
    return afterRoutes[0].url;
  } else {
    return "/";
  }
}
export const isLoggedIn = () => {
  let sessMax = getUserData("sessMax");
  if (sessMax && (sessMax < new Date().getTime())) {
    clearUserData();
  }
  return getUserData("isLoggedIn");
}



// WEBPACK FOOTER //
// ./src/helpers/User.js